import { Component, OnInit, NgZone } from '@angular/core';
import { NavController, Platform, ViewController } from 'ionic-angular';

import { DetallCarrer } from './../detallCarrer/detallCarrer';

import { State } from './../../providers/state';
import { FilterState } from '../../providers/filter_state';
import { GoogleMapsAPIWrapper } from 'angular2-google-maps/core';

declare var google:any;
declare var gmaps: any;

@Component({
  selector: 'mapa',
  templateUrl: 'mapa.html'
})
export class Mapa implements OnInit {

  public locations: any = [];
  public locationsFiltered: any = [];

  public lat: number = 42.0053531;
  public lng: number = 2.2960735;
  public myLocation: boolean = false;
  public preFiximgurl: string = "https://res.cloudinary.com/mei/image/fetch/w_300,h_300,c_thumb/";
  public lupaActive: boolean = true;
  public claseMapa: String;
  public filtres: any;

  constructor(
    public navCtrl: NavController,
    public platform: Platform,
    private zone:NgZone,
    public viewCtrl: ViewController,
    private filterState: FilterState,
    public state: State,
    private _wrapper: GoogleMapsAPIWrapper) {
        this._wrapper.getNativeMap().then((m) => {
            console.log('Got the map!: ', m);
        });
    }

  ngOnInit () {
    this.filtres = this.filterState.getFiltre();

    this.loadArray();
  }

  changeActive(event){
    this.lupaActive = event.value;
  }

  takeLlistatFiltres(event){
    this.filtres = event.value;
    this.filterLocations();
  }

  filterLocations () {
    this.locationsFiltered = this.locations.filter(location => {
      let isInRegim = this.filtres.regim.some(filtre => {
        return this.isInArray(filtre, location.Tipologia) || this.isInArray(filtre, location.Règim_prop)
      });
      let isInTipologia = this.filtres.tipologia.some(filtre => {
        return this.isInArray(filtre, location.Tipologia) || this.isInArray(filtre, location.Règim_prop);
      });
      return isInRegim && isInTipologia;
    });
    this.zone.run(() => {});

  }

  isInArray (string, searchString) {
    string  = string.trim().toLowerCase();
    searchString = searchString.trim().toLowerCase();
    return searchString.indexOf(string) !== -1
  }

  mapHeight(){
    let list = this.locationsFiltered.length !== 0;
    if(this.lupaActive && list){
      return "small_map";
    }else if(this.lupaActive && !list){
      return "mid_map";
    }else{
      return "big_map";
    }
  }

  goToDetallCarrer(location){
    this.navCtrl.push(DetallCarrer, {
      'OBJECTID': location.OBJECTID
    });
  }

  loadArray() {

    let style = {
      fillColor: '#333388',
      fillOpacity: 0.35,
      strokeColor: '#FFFFFF',
      strokeWeight: 1,
      strokeOpacity: 1,
      zIndex: 0
    };

    let url = 'https://services.arcgis.com/WNsrZDHEJ88NE4N8/ArcGIS/rest/services/Espais_lliures_polígons/FeatureServer/0';
    let layer = new gmaps.ags.Layer(url);
    let params = {
      returnGeometry: true,
      where: "1 = 1",
      outFields: ["OBJECTID", "Poligon","Adreça_ubi","Tipologia","Sup_interv","Superf_m2","Règim_prop","Disponibil","Empresa_Im","Tl_1contac","Tl_2contac","E_mail","Contacte","Descripció","foto","web_immob"],
      overlayOptions: style
    };

    this.processResultSet = this.processResultSet.bind(this);
    layer.query(params, this.processResultSet);
  }

  setupFeature (feat) {
    if(feat.geometry!=undefined && feat.attributes.Disponibil=="Sí"){
      let g = feat.geometry[0];//V3 supports multiple rings, so should have only 1 element

      feat.attributes["geo"] = this.getPolyCenter(g);
      this.locations.push(feat.attributes);
    }
  }

   processResultSet(rs) {
        var fs = rs.features;
        for (var i = 0, c = fs.length; i < c; i++) {
          this.setupFeature(fs[i]);
        }
        this.filterLocations();
      }

  getPolyCenter(poly) {
    let lat = 0;
    let lng = 0;
    let c = 0;
    let paths = poly.getPaths();
    for (var j = 0, jc = paths.getLength(); j < jc; j++) {
      let path = paths.getAt(j);
      for (var k = 0, kc = path.getLength(); k < kc; k++) {
        let latlng = path.getAt(k);
        lat += latlng.lat();
        lng += latlng.lng();
        c++;
      }
    }
    return c > 0 ? { "lat" : lat / c, "lng" : lng / c } : null;
  }

  setMarker(id){
    if(!this.state.comprovaImmobleExistent(id)){
      return 'assets/icon/favorite.png';
    }else{
      return 'assets/icon/point.png';
    }
  }

  setImg(urlFoto){
    if(urlFoto == " "){
      return "assets/img/gris.jpg";
    }else{
      return this.preFiximgurl + urlFoto;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/mapa/mapa.ts